
import { onMounted, nextTick, watch, ref, computed } from 'vue'
import DotQueTile from "@/components/Aio/DotQueTile.vue"
import store from '@/store/index'
export default {
  name: 'DotQue',
  props: {
    questionList: {
      type: Array,
      default: () => ([])
    },
    dotIndex: {
      type: String,
      default: '0'
    },
    curTime: {
      type: Number,
      default: 0
    },
    isCurrent: {
      type: Boolean,
      default: false
    }
  },
  components: {
    DotQueTile
  },
  emits: ['handleAfterRender'],
  setup(props, {emit}) {
    const handleAfterRender = () => {
      console.log('==========if isCurrent===========')
      props.isCurrent && emit('handleAfterRender', props.dotIndex)
    }
    onMounted(() => {
      handleAfterRender()
    })
    
    return {
      handleAfterRender
    }
  }
}
